import {
  checkIsMastraErrorToolOutput,
  type MastraErrorToolOutput,
} from "@repo/app-types/agents/mastraErrorToolOutput";
import type {
  SearchTeammatesToolInput,
  SearchTeammatesToolOutput,
} from "@repo/app-types/entities/copilot";
import { ChatToolBase, type ToolComponent } from "@repo/ui/chat/chatToolCall";
import { renderPlural } from "@repo/ui/helpers/helpers";

export const SearchTeammatesTool: ToolComponent<
  SearchTeammatesToolInput,
  SearchTeammatesToolOutput | MastraErrorToolOutput
> = (props) => {
  const renderText = () => {
    if (props.status.type !== "complete" || !props.output) {
      return "Looking up teammates...";
    }

    if (checkIsMastraErrorToolOutput(props.output)) {
      return "An error occurred while looking up teammates";
    }

    return renderPlural(props.output.teammates.length, {
      zero: "No teammates found",
      one: "Found 1 teammate",
      other: (count) => `Found ${count.toLocaleString()} teammates`,
    });
  };

  return <ChatToolBase status={props.status}>{renderText()}</ChatToolBase>;
};
